var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_vm._t("default")],2),_vm._l((_vm.events),function(event,i){return _c('event-card',{key:event.id,attrs:{"size":_vm.layout[i],"value":event}})})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }